import React, { useState, useRef, useEffect } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { verifyOtp } from '../../../../core/store/auth/verify-otp/thunk';
import { useNavigate } from 'react-router-dom';
import { createSelector } from '@reduxjs/toolkit';
import { resetRegisterFlag } from '../../../../core/store/auth/register/thunk';

const OTPValidationPage = () => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [errors, setError] = useState('');
  const [loader, setLoader] = useState(false);

  const [success, setSuccess] = useState(false);
  const [timer, setTimer] = useState(30);
  const refs = useRef([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    refs.current[0].focus();
    const interval = setInterval(() => {
      setTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);



  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(
    selectLayoutState,
    (state) => ({
      //user: account.user,
      errorMsg: state.Account.errorMsg,
      error: state.Account.error,
    })
  );
  // Inside your component
  const {
    user, error, loading, errorMsg
  } = useSelector(loginpageData);




  useEffect(() => {

    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetRegisterFlag());
        setLoader(false)

      }, 3000);
    }
  }, [dispatch, errorMsg]);
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (otp.join('').length === 6) {
      console.log(otp.join(''));
      const otpy = otp.join('');
      dispatch(verifyOtp(otpy, navigate));
      setLoader(true)

      // Ici, vous feriez normalement une requête à votre backend pour valider l'OTP
      /*   if (otp.join('') === '123456') { // Exemple de validation
          setSuccess(true);
          setError('');
        } else {
          setError('Code OTP invalide. Veuillez réessayer.');
        } */
    } else {
      setError('Veuillez entrer un code OTP complet.');
    }
  };

  const resendOTP = () => {
    // Ici, vous enverriez normalement une requête pour renvoyer un nouvel OTP
    setTimer(30);
    setOtp(['', '', '', '', '', '']);
    refs.current[0].focus();
    setError('');
    setSuccess(false);
  };

  return (
    <Container className="d-flex align-items-center justify-content-center min-vh-100">
      <Card className="shadow-lg" style={{ maxWidth: '400px', width: '100%' }}>
        <Card.Body className="p-5">
          <h2 className="text-center mb-4">Validation OTP</h2>
          <p className="text-center text-muted mb-4">
            Veuillez entrer le code à 6 chiffres envoyé à votre appareil.
          </p>

          <Form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-between mb-4 me-5">
              {otp.map((data, index) => (
                <Form.Control
                  key={index}
                  type="text"
                  maxLength="1"
                  ref={(element) => (refs.current[index] = element)}
                  value={data}
                  onChange={(e) => handleChange(e.target, index)}
                  onFocus={(e) => e.target.select()}
                  className="text-center mx-1"
                  style={{ width: '50px', height: '50px', fontSize: '1.5rem' }}
                />
              ))}
            </div>

            {error && <Alert variant="danger">{error}</Alert>}
            {success && (
              <Alert variant="success">OTP validé avec succès !</Alert>
            )}

            {/*  <Button 
              variant="primary" 
              type="submit" 
              className="w-100 mb-3"
              disabled={otp.join('').length !== 6}
            >
              Valider 
            </Button> */}
            <Button
                          variant="primary" 

              type="submit"
              className="w-100 mb-3"
              disabled={(loader && true )|| otp.join('').length !== 6}
            > {loader && <Spinner size="sm" className='me-2'></Spinner>}

Valider
            </Button>
          </Form>

          <div className="text-center">
            <Button
              variant="link"
              onClick={resendOTP}
              disabled={timer > 0}
              className="text-decoration-none"
            >

              Renvoyer le code {timer > 0 && `(${timer}s)`}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default OTPValidationPage;